import { FiFormEditComponent } from './fi-form-edit/fi-form-edit.component';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { AccessRightType } from '@fi-shared/types/access-right-type';
import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';
import { Ng2StateDeclaration, StatesModule, Transition } from '@uirouter/angular';
import { FiFormNavigationTabsComponent } from '@fi-app/fi-form/fi-form-navigation-tabs/fi-form-navigation-tabs.component';
import { FiFormListComponent } from '@fi-app/fi-form/fi-form-list/fi-form-list.component';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiFormService } from '@fi-app/fi-form/fi-form.service';
import { FiFormViewerContainerComponent } from '@fi-app/fi-form/fi-form-viewer/fi-form-viewer-container.component';
import { FiFormSharedService } from '@fi-shared/fi-form-shared/fi-form-shared.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

const FormState: Ng2StateDeclaration = {
    name: FiStateNames.Form._name,
    url: '/Form',
    abstract: true,
    component: FiFormNavigationTabsComponent,
};

const FormListState: Ng2StateDeclaration = {
    name: FiStateNames.Form.List,
    url: '/?:filterType&:sortColumn&:sortDirection&:offset',
    component: FiFormListComponent,
    reloadOnSearch: false,
};

const FormEditState: Ng2StateDeclaration = {
    name: FiStateNames.Form.Edit,
    url: '/Edit/{id:[0-9]+}?:preview',
    reloadOnSearch: false,
    params: {
        preview: null,
    },
    views: {
        '@Module': {
            component: FiFormEditComponent,
        },
    },
    resolve: {
        form: [FiFormService, FiStateService, Transition, FormEditForm],
    },
};

export function FormEditForm(formService: FiFormService, stateService: FiStateService, transition: Transition) {
    return formService.getForm(stateService.getParams(transition).id);
}

const FormAddState: Ng2StateDeclaration = {
    name: FiStateNames.Form.Add,
    url: '/Add?:preview',
    reloadOnSearch: false,
    params: {
        preview: null,
    },
    views: {
        '@Module': {
            component: FiFormEditComponent,
        },
    },
    resolve: {
        form: [FiFormService, FormAddForm],
    },
};

export function FormAddForm(formService: FiFormService) {
    return formService.getNewFormInstance();
}

const FormCopyState: Ng2StateDeclaration = {
    name: FiStateNames.Form.Copy,
    url: '/Copy/{id:[0-9]+}',
    reloadOnSearch: false,
    views: {
        '@Module': {
            component: FiFormEditComponent,
        },
    },
    resolve: {
        form: [FiFormService, FiStateService, Transition, formCopy_form],
    },
};

export function formCopy_form(formService: FiFormService, stateService: FiStateService, transition: Transition) {
    return formService.getFormCopy(stateService.getParams(transition).id);
}

const FormViewerState: Ng2StateDeclaration = {
    name: FiStateNames.Form.View,
    url: '/View/{id:[0-9]+}?:answerSetId',
    views: {
        '@Module': {
            component: FiFormViewerContainerComponent,
        },
    },
    resolve: {
        formViewer: [FiFormSharedService, FiStateService, Transition, FormViewForm],
        previousState: [Transition, PreviousState],
    },
};

export function FormViewForm(
    formSharedService: FiFormSharedService,
    stateService: FiStateService,
    transition: Transition,
) {
    return formSharedService.getFormViewer(
        stateService.getParams(transition).id,
        stateService.getParams(transition).answerSetId,
    );
}

export function PreviousState(transition: Transition) {
    return {
        from: transition.from(),
        params: transition.params('from'),
    };
}

export const FormStates: StatesModule = {
    states: [FormState, FormListState, FormEditState, FormAddState, FormCopyState, FormViewerState],
};

export function registerFormStateRules(stateAccessCheckService: StateAccessCheckService) {
    stateAccessCheckService.registerStateRules([FiStateNames.Form._name], {
        SettingType: [ApplicationSettingsType.FormLocal],
        AccessType: AccessRightType.Read,
    });
    stateAccessCheckService.registerStateRules([FiStateNames.Form.List], {
        SettingType: [ApplicationSettingsType.FormLocal],
        AccessType: AccessRightType.Read,
    });
    stateAccessCheckService.registerStateRules(
        [FiStateNames.Form.Edit, FiStateNames.Form.Add, FiStateNames.Form.Copy],
        {
            SettingType: [ApplicationSettingsType.FormLocal],
            AccessType: AccessRightType.Share,
        },
    );

    stateAccessCheckService.registerStateRules([FiStateNames.Form.View], {
        SettingType: [ApplicationSettingsType.FormLocal],
        AccessType: AccessRightType.Read,
    });
}
